// extracted by mini-css-extract-plugin
export var chevronIcon = "_dy-2";
export var teamName = "_dy-1";
export var teamSwitcherButton = "_dy-0";